import React from "react";
import { motion, AnimatePresence } from "framer-motion";

/* data imports */
import { dishIngredientsImagesObj } from "../game-data/ingredientsImagesObj";

/* animation imports */
import { ingredientEntryExit } from "../../assets/js/animations";

const IngredientsWrapper = ({
  activeDishIngredients,
  handleIngredientSelection,
  checkIngredientSelection,
  checkIngredientGroup,
  ingredientHoverHandler,
}) => {
  return (
    <div className="ingredients-wrapper">
      <AnimatePresence>
        {activeDishIngredients.length > 0 &&
          activeDishIngredients.map((item, index) => (
            <motion.div
              layout
              key={item.name}
              className={`ingredient-item ${
                checkIngredientSelection(item.name) ? "active" : ""
              } ${checkIngredientGroup(item.group) ? "disabled" : ""}`}
              onClick={() => handleIngredientSelection(item)}
              onMouseOver={() => ingredientHoverHandler(item.header)}
              onMouseOut={() => ingredientHoverHandler("")}
              custom={index}
              variants={ingredientEntryExit}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <div className="ingredient-item-img">
                <img
                  src={dishIngredientsImagesObj[item.imageLink]}
                  alt={item.header}
                />
              </div>
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default IngredientsWrapper;
